import { Controller } from "@hotwired/stimulus"
import { notifyOfflineWrite, writeFetch } from "./sweeper_shared"

export default class extends Controller {
  static values = {
    frameId: String,
    prereqId: String,
    state: String,
    url: String
  }

  async cycle() {
    const next = { na: "todo", todo: "done", done: "na" }[this.stateValue] || "todo"
    const response = await writeFetch(this.urlValue, {
      method: "PATCH",
      credentials: "include",
      headers: this.headers,
      body: JSON.stringify({ prereq_id: this.prereqIdValue, state: next })
    })

    if (!response.ok) return notifyOfflineWrite()

    this.dispatchSessionUpdated(await response.json())
    this.reloadFrame()
  }

  get headers() {
    return {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
    }
  }

  dispatchSessionUpdated(session) {
    document.dispatchEvent(new CustomEvent("sweeper:session-updated", { detail: { session } }))
  }

  reloadFrame() {
    const frame = document.getElementById(this.frameIdValue)
    if (frame && typeof frame.reload === "function") frame.reload()
  }
}
